import React from 'react'
import NavBarHomeDark from '../../../components/NavBar/NavBarHomeDark'
import Breadcrumbs from '../../courses/Breadcrumbs'
import Footer from '../../../components/Footer/Footer'
import InstructorProfile from './InstructorProfile'
import NavBarHome from '../../../components/NavBar/NavBarHome'

function InstructorsSingle() {
   return (
      <div className="pt-[92px] flex flex-col min-h-screen">
         <NavBarHome />

         <section className='py-12 px-4 md:px-8 lg:px-16 xl:px-[200px]'>
            <InstructorProfile />
         </section>

         <section className="mt-auto">
            <Footer
               logo={"/Logo NextMaker.png"}
               bgColor="bg-dark-1"
               textColor="text-gray-100"
               borderColor="border-gray-400/20"
            />
         </section>
      </div>
   )
}

export default InstructorsSingle